<template>
  <div>
    <u-error-handling
      v-if="errorObject_Backend"
      :error-object="errorObject_Backend"
    />
    <h3>Übersetzungen</h3>
    <!-- <u-error-handling v-if="errorObject" :error-object="errorObject" :property-mapping="errorPropertyMappings" /> -->
    <u-loader v-if="isLoading" />
    <div v-else>
      <!-- Übersetzung basierend auf Versionen -->
      <h4>Version</h4>
      <v-expansion-panel
        v-model="panel_version"
        expand
      >
        <v-expansion-panel-content
          v-for="(panelItem_version, i) in panelItems_version"
          :key="i"
          :class="getValidClass_Version(panelItem_version.reference)"
        >
          <template v-slot:header>
            <div>{{ panelItem_version.value }}</div>
          </template>
          <v-card
            class="pb-2 mb-4 ml-4 pl-3 pr-3 mt-3 objectCard"
            max-width="800"
          >
            <div
              v-for="(versionContent, j) in translationObject.versionContents"
              :key="j"
            >
              <div v-if="panelItem_version.reference == 'shortname'">
                <!-- Kurznane wird angepasst -->

                <translation-text-field
                  :language="versionContent.language"
                  :can-user-edit="canUserEdit"
                  :value="versionContent.nameShort"
                  @update:value="versionContent.nameShort = $event"
                  @updateValidation="updateValidation()"
                />
              </div>
              <div v-else-if="panelItem_version.reference == 'name'">
                <!-- Name wird angepasst -->
                <translation-text-field
                  :value="versionContent.value"
                  :language="versionContent.language"
                  :can-user-edit="canUserEdit"
                  @update:value="versionContent.value = $event"
                  @updateValidation="updateValidation()"
                />
              </div>
            </div>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <h4>Edition</h4>
      <!-- Übersetzung basierend auf Edition -->
      <div>
        <v-expansion-panel
          v-model="panel_translation"
          expand
        >
          <v-expansion-panel-content
            v-for="(panelItem_edition, i) in panelItems_edition"
            :key="i"
            :class="getValidClass_Header(panelItem_edition.reference)"
          >
            <template v-slot:header>
              <div>{{ panelItem_edition.value }}</div>
            </template>
            <!-- Dokumente übersetzungen -->
            <div>
              <div v-if="panelItem_edition.reference == 'documents'">
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].documents.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="
                    translationObject.editionsToTranslate[0].documents
                  "
                  translation-type="documents"
                />

                <v-card v-else>
                  <v-card-text class="grey lighten-3">
                    {{ getEmptyMsg(panelItem_edition.value) }}
                  </v-card-text>
                </v-card>
              </div>

              <!-- Links übersetzungen -->
              <div v-else-if="panelItem_edition.reference == 'links'">
                <translation-sub-panel
                  v-if="translationObject.editionsToTranslate[0].links.length"
                  :can-user-edit="canUserEdit"
                  :object-values="
                    translationObject.editionsToTranslate[0].links
                  "
                  translation-type="links"
                  @updateValidation="updateValidation()"
                />

                <v-card v-else>
                  <v-card-text class="grey lighten-3">
                    {{ getEmptyMsg(panelItem_edition.value) }}
                  </v-card-text>
                </v-card>
              </div>
              <!-- Klausel übersetzungen -->
              <div v-else-if="panelItem_edition.reference == 'klauseln'">
                <!-- Klausel -> Gav-Übersicht -->
                <h2
                  v-if="getKlauselnWithHeadPath('1/').length"
                  class="KlauselTitle"
                >
                  GAV-Übersicht
                </h2>

                <h4
                  v-if="getKlauselnWithPath('1/1/').length"
                  class="KlauselSubTitle"
                >
                  Geltungsbereiche
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('1/1/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />

                <h4
                  v-if="getKlauselnWithPath('1/2/').length"
                  class="KlauselSubTitle"
                >
                  Vertragsdauer
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('1/2/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />

                <h4
                  v-if="getKlauselnWithPath('1/3/').length"
                  class="KlauselSubTitle"
                >
                  Auskünfte
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('1/3/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <!-- Klausel -> Arbeitsbedigun -->
                <h2
                  v-if="getKlauselnWithHeadPath('2/').length"
                  class="KlauselTitle"
                >
                  Arbeitsbedingungen
                </h2>
                <h4
                  v-if="getKlauselnWithPath('2/1/').length"
                  class="KlauselSubTitle"
                >
                  Lohn und Lohnbestandteile
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('2/1/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <h4
                  v-if="getKlauselnWithPath('2/2/').length"
                  class="KlauselSubTitle"
                >
                  Lohnzuschläge
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('2/2/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <h4
                  v-if="getKlauselnWithPath('2/3/').length"
                  class="KlauselSubTitle"
                >
                  Arbeitszeit
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('2/3/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <h4
                  v-if="getKlauselnWithPath('2/4/').length"
                  class="KlauselSubTitle"
                >
                  Ferien und freie Tage
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('2/4/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <h4
                  v-if="getKlauselnWithPath('2/5/').length"
                  class="KlauselSubTitle"
                >
                  Lohnausfallentschädigungen
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('2/5/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <h4
                  v-if="getKlauselnWithPath('2/6/').length"
                  class="KlauselSubTitle"
                >
                  Vorsorge und Pensionierung
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('2/6/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <h4
                  v-if="getKlauselnWithPath('2/7/').length"
                  class="KlauselSubTitle"
                >
                  Beiträge
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('2/7/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <h4
                  v-if="getKlauselnWithPath('2/8/').length"
                  class="KlauselSubTitle"
                >
                  Arbeits- / Diskriminierungsschutz
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('2/8/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <h4
                  v-if="getKlauselnWithPath('2/9/').length"
                  class="KlauselSubTitle"
                >
                  Kündigung
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('2/9/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />

                <!-- Klausel -> Sozialpartnerschaft -->
                <h2
                  v-if="getKlauselnWithHeadPath('3/').length"
                  class="KlauselTitle"
                >
                  Sozialpartnerschaft
                </h2>
                <h4
                  v-if="getKlauselnWithPath('3/1/').length"
                  class="KlauselSubTitle"
                >
                  Vertragspartner
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('3/1/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <h4
                  v-if="getKlauselnWithPath('3/2/').length"
                  class="KlauselSubTitle"
                >
                  Finanzierung
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('3/2/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <h4
                  v-if="getKlauselnWithPath('3/3/').length"
                  class="KlauselSubTitle"
                >
                  Vollzug
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('3/3/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <h4
                  v-if="getKlauselnWithPath('3/4/').length"
                  class="KlauselSubTitle"
                >
                  Mitwirkung
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('3/4/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
                <h4
                  v-if="getKlauselnWithPath('3/5/').length"
                  class="KlauselSubTitle"
                >
                  Konfliktregelungen
                </h4>
                <translation-sub-panel
                  v-if="
                    translationObject.editionsToTranslate[0].klauseln.length
                  "
                  :can-user-edit="canUserEdit"
                  :object-values="getKlauselnWithPath('3/5/')"
                  :all-criterion-configuration="allCriterionConfiguration"
                  translation-type="klauseln"
                  @updateValidationKlausel="updateValidationKlausel()"
                />
              </div>

              <!-- Keine übersetzungen gefunden -->
              <div v-else>
                <v-card>
                  <v-card-text class="grey lighten-3">
                    {{ getEmptyMsg(panelItem_version.value) }}
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </div>

      <!-- Übersetzung basierend auf Mindestlöhne -->
      <div
        v-if="
          translationObject.editionsToTranslate[0]
            .mindestlohnConfigurationsToTranslate.length
        "
      >
        <div
          v-for="(mindestlohnConfiguration, i) in translationObject
            .editionsToTranslate[0].mindestlohnConfigurationsToTranslate"
          :key="i"
        >
          <h4>
            Mindestlohn-Konfiguration
            {{ mindestlohnConfiguration.configurationId }}
          </h4>

          <div>
            <v-expansion-panel
              v-model="
                panel_mindestlohn.parent_id[
                  mindestlohnConfiguration.configurationId
                ]
              "
              expand
            >
              <v-expansion-panel-content
                v-for="(panelItem_mindestlohn, j) in panelItems_mindestlohn"
                :key="j"
                :class="
                  getValidClass_Header(
                    panelItem_mindestlohn.reference,
                    mindestlohnConfiguration.configurationId,
                  )
                "
              >
                <template v-slot:header>
                  <div>{{ panelItem_mindestlohn.value }}</div>
                </template>
                <!-- Eingabekriterin -->
                <div
                  v-if="
                    panelItem_mindestlohn.reference ==
                      'criteriaListEntriesToTranslate'
                  "
                >
                  <translation-sub-panel
                    v-if="
                      mindestlohnConfiguration.criteriaListEntriesToTranslate
                        .length
                    "
                    :can-user-edit="canUserEdit"
                    :object-values="
                      mindestlohnConfiguration.criteriaListEntriesToTranslate
                    "
                    translation-type="criteriaListEntriesToTranslate"
                    @updateValidation="updateValidation()"
                  />
                  <v-card v-else>
                    <v-card-text class="grey lighten-3">
                      {{ getEmptyMsg(panelItem_mindestlohn.value) }}
                    </v-card-text>
                  </v-card>
                </div>

                <!-- Kriterien Struktur -->
                <div
                  v-else-if="
                    panelItem_mindestlohn.reference ==
                      'criteriaStructuresToTranslate'
                  "
                >
                  <translation-sub-panel
                    v-if="
                      mindestlohnConfiguration.criteriaStructuresToTranslate
                        .length
                    "
                    :can-user-edit="canUserEdit"
                    :object-values="
                      mindestlohnConfiguration.criteriaStructuresToTranslate
                    "
                    translation-type="criteriaStructuresToTranslate"
                    @updateValidation="updateValidation()"
                  />
                  <v-card v-else>
                    <v-card-text class="grey lighten-3">
                      {{ getEmptyMsg(panelItem_mindestlohn.value) }}
                    </v-card-text>
                  </v-card>
                </div>
                <!-- Alternativtexte -->
                <div
                  v-else-if="
                    panelItem_mindestlohn.reference ==
                      'alternativTextsToTranslate'
                  "
                >
                  <translation-sub-panel
                    v-if="
                      mindestlohnConfiguration.alternativTextsToTranslate.length
                    "
                    :can-user-edit="canUserEdit"
                    :object-values="
                      mindestlohnConfiguration.alternativTextsToTranslate
                    "
                    translation-type="alternativTextsToTranslate"
                    @updateValidation="updateValidation()"
                  />
                  <v-card v-else>
                    <v-card-text class="grey lighten-3">
                      {{ getEmptyMsg(panelItem_mindestlohn.value) }}
                    </v-card-text>
                  </v-card>
                </div>

                <!-- Textblock -->
                <div
                  v-else-if="
                    panelItem_mindestlohn.reference == 'textblocksToTranslate'
                  "
                >
                  <translation-sub-panel
                    v-if="mindestlohnConfiguration.textblocksToTranslate.length"
                    :can-user-edit="canUserEdit"
                    :object-values="
                      mindestlohnConfiguration.textblocksToTranslate
                    "
                    translation-type="textblocksToTranslate"
                    @updateValidation="updateValidation()"
                  />
                  <v-card v-else>
                    <v-card-text class="grey lighten-3">
                      {{ getEmptyMsg(panelItem_mindestlohn.value) }}
                    </v-card-text>
                  </v-card>
                </div>

                <div v-else>
                  <v-card>
                    <v-card-text class="grey lighten-3">
                      Keine Einträge vorhanden.
                    </v-card-text>
                  </v-card>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </div>
        </div>
      </div>

      <div v-if="canUserEdit">
        <div>
          <v-btn
            tile
            color="success"
            @click="saveTranslations"
          >
            <i class="fas fa-save pr-2" />
            Speichern
          </v-btn>
          <v-btn
            tile
            color="#e72b37"
            style="color: white"
            @click="cancelEditTranslation"
          >
            <i class="fas fa-ban pr-2" />
            Abbrechen
          </v-btn>
        </div>

        <div v-if="isFormValide">
          <hr class="mt-5 mb-5">

          <div>
            <h3>Fehlende Einträge</h3>

            <error-box
              v-if="
                validatedVersionObject.errorObject &&
                  validatedVersionObject.errorObject.length
              "
              title="Version"
              :errors-object="validatedVersionObject.errorObject"
            />

            <error-box
              v-if="
                validatedLinksObject.errorObject &&
                  validatedLinksObject.errorObject.length
              "
              title="Links"
              :errors-object="validatedLinksObject.errorObject"
            />

            <error-box
              v-if="
                validatedKlauselObject.errorObject &&
                  validatedKlauselObject.errorObject.length
              "
              title="Klauseln"
              :errors-object="validatedKlauselObject.errorObject"
            />

            <div
              v-for="(mindestlohnObject, i) in validatedMindestlohnObject"
              :key="i"
            >
              <div
                v-if="isCurrentMindestlohnValide(mindestlohnObject.parent_id)"
              >
                <h4 class="pt-4">
                  Mindestlohn-Konfiguration {{ mindestlohnObject.parent_id }}
                </h4>
                <error-box
                  v-if="
                    mindestlohnObject.validatedAlternativTexts.errorObject &&
                      mindestlohnObject.validatedAlternativTexts.errorObject
                        .length
                  "
                  title="Alternativtexte"
                  :errors-object="
                    mindestlohnObject.validatedAlternativTexts.errorObject
                  "
                />

                <error-box
                  v-if="
                    mindestlohnObject.validatedCriteriaEntries.errorObject &&
                      mindestlohnObject.validatedCriteriaEntries.errorObject
                        .length
                  "
                  title="Kriterien Eingabekriterien"
                  :errors-object="
                    mindestlohnObject.validatedCriteriaEntries.errorObject
                  "
                />

                <error-box
                  v-if="
                    mindestlohnObject.validatedCriteriaStruct.errorObject &&
                      mindestlohnObject.validatedCriteriaStruct.errorObject.length
                  "
                  title="Kriterien Struktur"
                  :errors-object="
                    mindestlohnObject.validatedCriteriaStruct.errorObject
                  "
                />

                <error-box
                  v-if="
                    mindestlohnObject.validatedTextblocks.errorObject &&
                      mindestlohnObject.validatedTextblocks.errorObject.length
                  "
                  title="Textblöcke"
                  :errors-object="
                    mindestlohnObject.validatedTextblocks.errorObject
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetTranslation,
  UpdateTranslation,
} from "@/services/contract.edition.translation.service.js";
import TranslationSubPanel from "./EditionTranslations_SubPanel";
import TranslationTextField from "./EditionTranslations_TextField";
import ErrorBox from "./EditionTranslations_ErrorBox";
import {
  validateVersions,
  validateLinks,
  validateKlauseln,
  validateAlternativeTexte,
  validateEingabekriterien,
  validateEingabestruktur,
  validateTextblocks,
} from "@/helpers/TranslationValidationHelper.js";
import { LoadAllCriterionConfigurations } from "@/services/criterion.management.service.js";
import { GetVersionInformation } from "@/services/contract.service.js";

export default {
  components: {
    TranslationSubPanel,
    TranslationTextField,
    ErrorBox,
  },
  props: {
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
    canUserEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      errorObject: null,
      errorObject_Backend: null,
      panelItems_edition: [
        // { value: "Anlagen - Dokumente", reference: "documents" },
        { value: "Links", reference: "links" },
        { value: "Klauseln", reference: "klauseln" },
      ],
      panelItems_mindestlohn: [
        { value: "Alternativtexte", reference: "alternativTextsToTranslate" },
        {
          value: "Kriterien Eingabekriterien",
          reference: "criteriaListEntriesToTranslate",
        },
        {
          value: "Kriterien Struktur",
          reference: "criteriaStructuresToTranslate",
        },
        { value: "Textblöcke", reference: "textblocksToTranslate" },
      ],
      panelItems_version: [
        { value: "Name des Vertrags", reference: "name" },
        { value: "Kurzname", reference: "shortname" },
      ],

      panel_translation: [],
      panel_mindestlohn: {
        parent_id: [],
      },
      panel_version: [],
      translationObject: {},
      originalTranslationObject: {},
      allCriterionConfiguration: [],

      validatedKlauselObject: [],
      validatedVersionObject: [],
      validatedDocumentsObject: [],
      validatedLinksObject: [],
      validatedMindestlohnObject: [],

      translatedToLanguages: [],

      validationTest: false,

      activateValidator: false,
    };
  },

  computed: {
    //check if form is Valide
    isFormValide() {
      let mindestlohnObjectHasError = 0;

      if (this.validatedMindestlohnObject.length) {
        this.validatedMindestlohnObject.forEach((mindestlohnObject) => {
          if (
            mindestlohnObject.validatedAlternativTexts.errorObject.length ||
            mindestlohnObject.validatedCriteriaEntries.errorObject.length ||
            mindestlohnObject.validatedCriteriaStruct.errorObject.length ||
            mindestlohnObject.validatedTextblocks.errorObject.length
          ) {
            mindestlohnObjectHasError = 1;
          }
        });
      }

      return (
        (this.validatedKlauselObject.errorObject &&
          this.validatedKlauselObject.errorObject.length) ||
        (this.validatedLinksObject.errorObject &&
          this.validatedLinksObject.errorObject.length) ||
        (this.validatedDocumentsObject.errorObject &&
          this.validatedDocumentsObject.errorObject.length) ||
        (this.validatedVersionObject.errorObject &&
          this.validatedVersionObject.errorObject.length) ||
        mindestlohnObjectHasError
      );
    },
  },

  created() {
    console.clear();

    GetVersionInformation(
      this.contractId,
      this.versionId,
      (result) => {
        this.translatedToLanguages = result.translatedToLanguages;
      },
      (error) => {
        console.log(error);
      },
    );

    this.isLoading = true;
    this.loadTranslations();
  },
  methods: {
    isCurrentMindestlohnValide(configurationId) {
      const currentMindestLohnobject = this.validatedMindestlohnObject.find(
        (mindestlohnObject) => mindestlohnObject.parent_id == configurationId,
      );

      return (
        currentMindestLohnobject.validatedAlternativTexts.errorObject.length ||
        currentMindestLohnobject.validatedCriteriaEntries.errorObject.length ||
        currentMindestLohnobject.validatedCriteriaStruct.errorObject.length ||
        currentMindestLohnobject.validatedTextblocks.errorObject.length
      );
    },
    updateValidationKlausel() {
      this.validatedKlauselObject = validateKlauseln(
        JSON.parse(
          JSON.stringify(
            this.translationObject.editionsToTranslate[0].klauseln,
          ),
        ),
        this.allCriterionConfiguration,
        this.translatedToLanguages,
      );
      this.translationObject.editionsToTranslate[0].klauseln = JSON.parse(
        JSON.stringify(this.validatedKlauselObject.newKlauselObject),
      );
    },
    updateValidation() {
      this.validateTranslations();
    },
    getKlauselnWithPath(path) {
      return this.translationObject.editionsToTranslate[0].klauseln.filter(
        (klausel) => {
          if (klausel.klauselContents[0].klauselPath) {
            return klausel.klauselContents[0].klauselPath.slice(0, -2) == path;
          }
        },
      );
    },
    getKlauselnWithHeadPath(path) {
      return this.translationObject.editionsToTranslate[0].klauseln.filter(
        (klausel) => {
          if (klausel.klauselContents[0].klauselPath) {
            return klausel.klauselContents[0].klauselPath.slice(0, -4) == path;
          }
        },
      );
    },

    getValidClass_Version(reference) {
      if (reference == "shortname") {
        const valideObject_shortName =
          this.validatedVersionObject.validationObject.filter(
            (validateValue) => validateValue.valid_nameShort == false,
          );
        return {
          toppanel_valide: !valideObject_shortName.length,
          toppanel: valideObject_shortName.length,
        };
      } else {
        const valideObject =
          this.validatedVersionObject.validationObject.filter(
            (validateValue) => validateValue.valid_value == false,
          );
        return {
          toppanel_valide: !valideObject.length,
          toppanel: valideObject.length,
        };
      }
    },
    getValidClass_Header(reference, configurationId) {
      let currentObject = "";
      if (reference == "links") {
        currentObject = this.validatedLinksObject.validationObject;
      } else if (reference == "klauseln") {
        currentObject = this.validatedKlauselObject.newKlauselObject;
      } else if (configurationId) {
        const currentMindestLohnobject = this.validatedMindestlohnObject.find(
          (mindestlohnObject) => mindestlohnObject.parent_id == configurationId,
        );

        if (reference == "alternativTextsToTranslate") {
          currentObject =
            currentMindestLohnobject.validatedAlternativTexts.validationObject;
        } else if (reference == "criteriaListEntriesToTranslate") {
          currentObject =
            currentMindestLohnobject.validatedCriteriaEntries.validationObject;
        } else if (reference == "criteriaStructuresToTranslate") {
          currentObject =
            currentMindestLohnobject.validatedCriteriaStruct.validationObject;
        } else if (reference == "textblocksToTranslate") {
          currentObject =
            currentMindestLohnobject.validatedTextblocks.validationObject;
        }
      }

      if (currentObject) {
        const valideObject = currentObject.filter(
          (validateValue) => validateValue.valid_value == false,
        );
        return {
          toppanel_valide: !valideObject.length,
          toppanel: valideObject.length,
        };
      }
    },
    getEmptyMsg(value) {
      return "Keine Einträge zu ( " + value + ") vorhanden.";
    },
    loadTranslations() {
      GetTranslation(
        this.contractId,
        this.versionId,
        this.editionId,
        (response) => {
          this.translationObject = response;

          this.loadAllCriterionConfigurations();
        },
        (error) => {
          this.isLoading = false;
          this.loadingError = true;
          this.errorObject_Backend = error;
        },
      );
    },

    async saveTranslations() {
      this.isLoading = true;
      this.errorObject_Backend = null;
      await this.validateTranslations();

      UpdateTranslation(
        this.contractId,
        this.versionId,
        this.editionId,
        this.getNewTranslationObject(),
        (response) => {
          if (response.data) {
            this.translationObject = JSON.parse(JSON.stringify(response.data));
            this.originalTranslationObject = JSON.parse(
              JSON.stringify(response.data),
            );
          } else {
            this.translationObject = JSON.parse(JSON.stringify(response));
            this.originalTranslationObject = JSON.parse(
              JSON.stringify(response),
            );
          }
          this.filterKlauselnObject();
          this.validateTranslations();

          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;

          this.errorObject_Backend = error;
        },
      );
    },
    cancelEditTranslation() {
      this.isLoading = true;
      this.translationObject = JSON.parse(
        JSON.stringify(this.originalTranslationObject),
      );
      this.validateTranslations();
      setTimeout(() => {
        this.isLoading = false;
      }, "50");
    },
    loadAllCriterionConfigurations() {
      LoadAllCriterionConfigurations(
        (response) => {
          this.allCriterionConfiguration = JSON.parse(JSON.stringify(response));

          this.filterKlauselnObject();

          this.validateTranslations();

          this.originalTranslationObject = JSON.parse(
            JSON.stringify(this.translationObject),
          );

          this.activateValidator = true;

          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.errorObject_Backend = error;
        },
      );
    },
    filterKlauselnObject() {
      this.translationObject.editionsToTranslate[0].klauseln = validateKlauseln(
        JSON.parse(
          JSON.stringify(
            this.translationObject.editionsToTranslate[0].klauseln,
          ),
        ),
        this.allCriterionConfiguration,
        this.translatedToLanguages,
      ).newKlauselObject;
    },

    async validateTranslations() {
      this.activateValidator = false;

      await this.setValidateObject();

      this.activateValidator = true;
    },

    getNewTranslationObject() {
      let newTranslationObject = JSON.parse(
        JSON.stringify(this.translationObject),
      );
      let counter = 0;

      newTranslationObject.versionContents =
        this.validatedVersionObject.newVersionsObject;
      newTranslationObject.editionsToTranslate[0].documents =
        this.validatedDocumentsObject.originalObject;
      newTranslationObject.editionsToTranslate[0].klauseln =
        this.validatedKlauselObject.originalObject;
      newTranslationObject.editionsToTranslate[0].links =
        this.validatedLinksObject.originalObject;

      if (this.validatedMindestlohnObject.length) {
        this.validatedMindestlohnObject.forEach(
          (mindestlohnConfiguration, i) => {
            newTranslationObject.editionsToTranslate[0].mindestlohnConfigurationsToTranslate[
              i
            ].alternativTextsToTranslate =
              mindestlohnConfiguration.validatedAlternativTexts.originalObject;
            newTranslationObject.editionsToTranslate[0].mindestlohnConfigurationsToTranslate[
              i
            ].criteriaListEntriesToTranslate =
              mindestlohnConfiguration.validatedCriteriaEntries.originalObject;
            newTranslationObject.editionsToTranslate[0].mindestlohnConfigurationsToTranslate[
              i
            ].criteriaStructuresToTranslate =
              mindestlohnConfiguration.validatedCriteriaStruct.originalObject;
            newTranslationObject.editionsToTranslate[0].mindestlohnConfigurationsToTranslate[
              i
            ].textblocksToTranslate =
              mindestlohnConfiguration.validatedTextblocks.originalObject;
            counter++;
          },
        );
      }
      if (this.validatedMindestlohnObject.length == counter) {
        return newTranslationObject;
      }
    },
    setValidateObject() {
      //Reset Array, prevents multiple entrys
      this.validatedMindestlohnObject = [];
      //Validierung Version
      this.validatedVersionObject = validateVersions(
        JSON.parse(JSON.stringify(this.translationObject.versionContents)),
      );
      this.translationObject.versionContents = JSON.parse(
        JSON.stringify(this.validatedVersionObject.validationObject),
      );
      //Validierung Edition
      //Links
      this.validatedLinksObject = validateLinks(
        JSON.parse(
          JSON.stringify(this.translationObject.editionsToTranslate[0].links),
        ),
      );
      this.translationObject.editionsToTranslate[0].links = JSON.parse(
        JSON.stringify(this.validatedLinksObject.validationObject),
      );
      //Klauseln
      this.validatedKlauselObject = validateKlauseln(
        JSON.parse(
          JSON.stringify(
            this.translationObject.editionsToTranslate[0].klauseln,
          ),
        ),
        this.allCriterionConfiguration,
        this.translatedToLanguages,
      );
      this.translationObject.editionsToTranslate[0].klauseln = JSON.parse(
        JSON.stringify(this.validatedKlauselObject.newKlauselObject),
      );

      //Validierung Mindestlohn
      if (
        this.translationObject.editionsToTranslate[0]
          .mindestlohnConfigurationsToTranslate.length
      ) {
        this.translationObject.editionsToTranslate[0].mindestlohnConfigurationsToTranslate.forEach(
          (mindestlohnConfiguration, i) => {
            //Eingabestruktur validieren
            const validatedCriteriaStruct = validateEingabestruktur(
              JSON.parse(
                JSON.stringify(
                  this.translationObject.editionsToTranslate[0]
                    .mindestlohnConfigurationsToTranslate[i]
                    .criteriaStructuresToTranslate,
                ),
              ),
            );

            //Alternativetexte validieren
            const validatedAlternativTexts = validateAlternativeTexte(
              JSON.parse(
                JSON.stringify(
                  this.translationObject.editionsToTranslate[0]
                    .mindestlohnConfigurationsToTranslate[i]
                    .alternativTextsToTranslate,
                ),
              ),
            );

            //Eingabekriterien validieren
            const validatedCriteriaEntries = validateEingabekriterien(
              JSON.parse(
                JSON.stringify(
                  this.translationObject.editionsToTranslate[0]
                    .mindestlohnConfigurationsToTranslate[i]
                    .criteriaListEntriesToTranslate,
                ),
              ),
            );

            //Textblock validieren
            const validatedTextblocks = validateTextblocks(
              JSON.parse(
                JSON.stringify(
                  this.translationObject.editionsToTranslate[0]
                    .mindestlohnConfigurationsToTranslate[i]
                    .textblocksToTranslate,
                ),
              ),
            );
            this.validatedMindestlohnObject.push({
              parent_id: mindestlohnConfiguration.configurationId,
              //Eingabestruktur
              validatedCriteriaStruct: validatedCriteriaStruct,
              //Alternativtexte
              validatedAlternativTexts: validatedAlternativTexts,
              //Eingabekriterien
              validatedCriteriaEntries: validatedCriteriaEntries,
              //Textblock
              validatedTextblocks: validatedTextblocks,
            });

            //Alternativtexte ersetzen
            this.translationObject.editionsToTranslate[0].mindestlohnConfigurationsToTranslate[
              i
            ].alternativTextsToTranslate = JSON.parse(
              JSON.stringify(validatedAlternativTexts.validationObject),
            );
            //Eingabekriterien ersetzen
            this.translationObject.editionsToTranslate[0].mindestlohnConfigurationsToTranslate[
              i
            ].criteriaListEntriesToTranslate = JSON.parse(
              JSON.stringify(validatedCriteriaEntries.validationObject),
            );
            //Eingabestruktur ersetzen
            this.translationObject.editionsToTranslate[0].mindestlohnConfigurationsToTranslate[
              i
            ].criteriaStructuresToTranslate = JSON.parse(
              JSON.stringify(validatedCriteriaStruct.validationObject),
            );
            //Textblock ersetzen
            this.translationObject.editionsToTranslate[0].mindestlohnConfigurationsToTranslate[
              i
            ].textblocksToTranslate = JSON.parse(
              JSON.stringify(validatedTextblocks.validationObject),
            );
          },
        );
      }
    },
  },
};
</script>

<style>
.KlauselTitle {
  background-color: white !important;
  background: white !important;
  color: black !important;

  border-left: 6px solid black;

  padding: 10px 0px 10px 10px;

  margin-bottom: 0px;
  margin-top: 5px;
}
.KlauselSubTitle {
  background-color: white !important;
  background: white !important;
  color: black !important;

  border-left: 6px solid darkgrey;

  padding: 10px 0px 10px 10px;
  margin: 5px 0px;
}

.toppanel .v-expansion-panel__header {
  background: rgb(198, 40, 40);
  color: white;
  transition: background 0.4s linear;
}

.toppanel_valide .v-expansion-panel__header {
  /* background: #018749; */
  background: rgb(76, 175, 80);

  /* background: rgb(233, 245, 234);
  color: rgb(76, 175, 80);
  border-left: 6px solid rgb(76, 175, 80); */
  font-weight: bold;

  color: white;
  transition: background 0.4s linear;
}
</style>
